module.exports = __webpack_public_path__ + "static/tab1-a74dd1755f33ad934ae12c53f25bb276.jpg";